import { useQuery } from 'react-query';

import { getIntegratedScheduleDetails as queryFn } from 'api/endPoints/getIntegratedScheduleDetails';

export const useQueryGetIntegratedScheduleDetails = (params: { fileMetaDataId: number }) => {
    return useQuery<unknown, QueryError>({
        queryKey: ['getIntegratedScheduleDetails', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.fileMetaDataId),
    });
};
